import React from 'react';
import { Input, Select } from 'antd';

export const LabeledInput = ({ label, ...inputProps }) => (
    <Input className="ewtFixedLabelInput" addonBefore={label} {...inputProps} />
);

export const LabeledSelect = ({ label, ...selectProps }) => (
    <div className="ewtFixedLabelRow">
        <span className="ewtFixedLabelAddon">{label}</span>
        <Select {...selectProps} />
    </div>
);
